(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var dataEl = document.getElementById('hs-cross-sell-data');
    var modal = document.getElementById('hs-xsell-modal');
    if (!dataEl || !modal) return;

    var CORE = [];
    try {
      CORE = (JSON.parse(dataEl.textContent) || {}).products || [];
    } catch (e) {
      CORE = [];
    }
    if (!CORE.length) return;

    var cardsWrap = modal.querySelector('[data-hs-xsell-cards]');
    var subEl = modal.querySelector('[data-hs-xsell-sub]');
    var addBtn = modal.querySelector('[data-hs-xsell-add]');
    var skipEls = modal.querySelectorAll('[data-hs-xsell-skip]');

    function money(amountCents) {
      if (typeof amountCents !== 'number') return '';
      return '$' + (amountCents / 100).toFixed(2);
    }

    function percentOff(price, compareAt) {
      if (!compareAt || compareAt <= price) return null;
      return Math.round(((compareAt - price) / compareAt) * 100);
    }

    // -------------------------------------------------------------------
    // Build the /cart/add payload explicitly instead of serializing the form.
    //
    // THIS IS THE FIX for One-Time purchases arriving as subscriptions.
    //
    // The old code did `new FormData(form)`, which sweeps up every named field
    // in the DOM. Two ways that went wrong:
    //
    //   1. The PDP renders a hidden `selling_plan` field. Sent blank, Shopify
    //      does NOT read that as "no plan" — it reads the presence of the key
    //      as "apply a plan" and resolves the blank value to the variant's
    //      default. A customer who picked One-Time got a subscription in cart
    //      and at checkout.
    //   2. A subscription app can inject its own `selling_plan` control into
    //      the same form. headstrong-pdp.css hides those, but display:none
    //      does not stop a field serializing, and the later duplicate wins.
    //
    // Reading only the fields we know about closes both. `selling_plan` is
    // included ONLY when it is present, enabled, and non-blank — i.e. only
    // when the customer actively chose Subscribe.
    //
    // Do not replace this with FormData.
    // -------------------------------------------------------------------
    function buildAddPayload(form) {
      var idEl = form.querySelector('[name="id"]:not([disabled])');
      var qtyEl = form.querySelector('[name="quantity"]:not([disabled])');

      var payload = {
        id: idEl ? idEl.value : null,
        quantity: (qtyEl && parseInt(qtyEl.value, 10)) || 1
      };

      var planEl = form.querySelector('[data-hs-selling-plan-input]:not([disabled])');
      var plan = planEl && planEl.value ? String(planEl.value).trim() : '';
      if (plan) payload.selling_plan = plan;

      return payload;
    }

    function goToCheckout() {
      window.location.href = '/checkout';
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hs-xsell-modal-open');
    }

    function openModal(missing) {
      cardsWrap.innerHTML = '';
      missing.forEach(function (p) {
        var pct = percentOff(p.price, p.compareAtPrice);
        var card = document.createElement('label');
        card.className = 'hs-xsell-card';

        var media = '';
        if (p.image) {
          media = '<img src="' + p.image + '" alt="" loading="lazy">';
        }

        var priceHtml = money(p.price);
        if (pct) {
          priceHtml += ' <s>' + money(p.compareAtPrice) + '</s> <b>' + pct + '% OFF</b>';
        }

        card.innerHTML =
          '<input type="checkbox" class="hs-xsell-card__check" checked data-variant-id="' + p.variantId + '">' +
          '<span class="hs-xsell-card__media">' + media + '</span>' +
          '<span class="hs-xsell-card__body">' +
            '<span class="hs-xsell-card__name">' + p.title + '</span>' +
            '<span class="hs-xsell-card__price">' + priceHtml + '</span>' +
          '</span>';
        cardsWrap.appendChild(card);
      });

      if (missing.length > 1) {
        subEl.textContent = "You're missing " + missing.length + ' formulas from your daily system — add them now and save.';
      } else {
        subEl.textContent = 'Complete your daily system — add ' + missing[0].title + ' and save.';
      }

      addBtn.disabled = false;
      addBtn.textContent = 'Add Selected & Checkout';

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hs-xsell-modal-open');
    }

    function getMissing(cartItems) {
      var presentHandles = {};
      (cartItems || []).forEach(function (item) {
        var handle = item.handle || item.product_handle;
        if (handle) presentHandles[handle] = true;
      });
      var present = CORE.filter(function (p) { return presentHandles[p.handle]; });
      var missing = CORE.filter(function (p) { return !presentHandles[p.handle]; });
      if (present.length === 0 || missing.length === 0) return [];
      return missing;
    }

    // Checks the live cart and either shows the popup or calls proceedFn().
    // Always fails open — any error just proceeds to checkout.
    function checkAndProceed(proceedFn) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var missing = getMissing(cart.items);
          if (missing.length) {
            openModal(missing);
          } else {
            proceedFn();
          }
        })
        .catch(function () {
          proceedFn();
        });
    }

    addBtn.addEventListener('click', function () {
      var checks = cardsWrap.querySelectorAll('.hs-xsell-card__check:checked');
      if (!checks.length) {
        closeModal();
        goToCheckout();
        return;
      }
      // DELIBERATE: cross-sell add-ons are always ONE-TIME, never subscription,
      // even when the main line item is a subscription. The customer chose a
      // purchase option for the product they were looking at, not for these.
      // The modal footer tells them Subscribe & Save is available at checkout.
      // If this ever changes, it needs a visible per-item control in the modal
      // — do not silently inherit the parent line's selling plan.
      var items = Array.prototype.map.call(checks, function (c) {
        return { id: c.getAttribute('data-variant-id'), quantity: 1 };
      });
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function () {
          closeModal();
          goToCheckout();
        })
        .catch(function () {
          closeModal();
          goToCheckout();
        });
    });

    skipEls.forEach(function (el) {
      el.addEventListener('click', function () {
        closeModal();
        goToCheckout();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (!modal.hidden && e.key === 'Escape') {
        closeModal();
        goToCheckout();
      }
    });

    // Entry point 1: native Shopify checkout buttons — cart page and cart
    // drawer both use <button name="checkout">. Items are already in the
    // cart at this point, so we just check and either show the popup or
    // go straight to checkout.
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[name="checkout"]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      checkAndProceed(goToCheckout);
    }, true);

    // Entry point 2: "buy now" forms that submit straight to /checkout via
    // a hidden return_to field (hero form, PDP buy box, PDP sticky bar).
    // Add the item via AJAX first, then check the resulting cart.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var returnTo = form.querySelector('input[name="return_to"]');
      if (!returnTo || returnTo.value.indexOf('/checkout') === -1) return;

      e.preventDefault();
      e.stopPropagation();

      var payload = buildAddPayload(form);
      if (!payload.id) {
        // Nothing sane to add — let the native submit take over rather than
        // silently swallowing the customer's click.
        form.submit();
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function () {
          checkAndProceed(goToCheckout);
        })
        .catch(function () {
          goToCheckout();
        });
    }, true);
  });
})();
